export default __webpack_public_path__ + "static/media/Foto-393-300x200.2109fd18.png";